import React, { Component } from 'react';
import OriginUpload from 'bee-upload';
import { isFunction, gzip as Gzip, getAppReqParam, getCookie, getGlobalStorage, getTopWindow, encryptFormData, decryptFormData } from '@platform/api';

import { Cipher } from '@platform/api';
import Loading from '../Loading';

require('bee-upload/build/Upload.css');

// 由于是从api中导出
const CipherControl = Cipher.default;

let sendChildDate = null; //chendc修改，为了导入的时候使用此参数与进度同步
let cckk = (top && getTopWindow().cookiets) || getCookie('cookiets') || Date.now(); //双cookie验证 liuxis
// 做一次 数据转型
cckk = isNaN(cckk) ? cckk : Number(cckk);
// 加密 bbqin
//let cipherFlag = getGlobalStorage('localStorage', 'rockin');
let NCC_SYS_Switch = JSON.parse(localStorage.getItem('NCC_SYS_Switch')) || {};
let cipherFlag = NCC_SYS_Switch.aesKey;

// 将是否加密缓存到组件单例上
CipherControl.CipherFlag = cipherFlag;

// 处理系统变量
function getSysterm() {
    // 从ajax哪里取得，目的获取busiaction
    let { app, appcode } = getAppReqParam();

    let busiaction = `${app || null}-${window.actionName || null}`;
    //chendc修改 上传点击触发setState会导致时间重置，进度标记不再统一
    sendChildDate = sendChildDate || String(new Date().getTime());

    let sysParamJson = {
        sys_busiaction: busiaction,
        sys_appcode: appcode,
        sys_ts: sendChildDate,
    };

    return sysParamJson;
}

function decrptyResponse(response, headers) {
    let gzip = NCC_SYS_Switch.gzip;
    let cckks = headers ? String(headers['crux']) : String(cckk);
    // 先进行 解密处理 bbqin
    let aeskey = Cipher.opaqueDecrypt(getGlobalStorage('localStorage', 'cowboy'));
    aeskey = cckks + aeskey.substring(0, aeskey.length - cckks.length);
    response =
        typeof response === 'string'
            ? CipherControl.decrypt(response, aeskey)
            : response;
    if (gzip) {
        console.log('开始解压');
        let gziptools = new Gzip();
        response = gziptools.unzip(response);
        console.log('压缩开关值：', response);
    }
    console.log('解压完成，处理数据结果：', response);
    return response;
}
export default class Upload extends Component {
    constructor(props) {
        super(props);
        this.state = { loading: false };
        this.defaultCrux = cckk || (new Date().getTime());
    }

    uploadChange = info => {
        let { file } = info;

        let {
            status, // 状态 'uploading' 'done' 'error'
            response,
        } = file;
        let { showLoading = true, headers = {} } = this.props;
        headers['crux'] = String(headers['crux'] || this.defaultCrux);

        if (status == 'uploading' && showLoading) {
            this.setState({
                loading: true,
            });
        } else if (status == 'done') {
            file.response = decrptyResponse(response, headers);

            if (showLoading) {
                this.setState({
                    loading: false,
                });
            }
        }
        if (isFunction(this.props.NcUploadOnChange)) {
            this.props.NcUploadOnChange(info, { sendChildDate });
        }

        if (isFunction(this.props.onChange)) {
            this.props.onChange(info);
        }
        sendChildDate = null;
    };

    render() {
        let { data = {}, headers = {} } = this.props;
        // 传递加密参数
        headers['crux'] = String(headers['crux'] || this.defaultCrux);

        //表单提交数据加密  后台需要继承朱威的公共类
        let sysParamJson = getSysterm();
        let appcode = sysParamJson.sys_appcode;
        //chendch修改，导入进度查询唯一标记
        let sys_ts_uap = sysParamJson.sys_ts;
        sysParamJson = encryptFormData(JSON.stringify(sysParamJson));

        let busiParamJson = encryptFormData(JSON.stringify({ ...data, importSign: sys_ts_uap }));

        let uploadData = {
            sysParamJson,
            sys_appcode: appcode,
            busiParamJson
        };

        console.log('外界设置参数属性（props）：', this.props);
        console.log('外界设置data参数：', data);

        return (
            <span>
                <OriginUpload
                    {...this.props}
                    data={uploadData}
                    headers={headers}
                    onChange={this.uploadChange}
                />
                <Loading
                    show={this.state.loading}
                    fullScreen
                />
            </span>
        );
    }
}

class Dragger extends Component {
    constructor(props) {
        super(props);
        this.defaultCrux = cckk || (new Date().getTime());
    }

    uploadChange = info => {
        let { file = {} } = info;
        let { response } = file;
        let { onChange, headers = {} } = this.props;
        headers['crux'] = String(headers['crux'] || this.defaultCrux);

        if (response) {
            file.response = decrptyResponse(response, headers);
        }
        if (isFunction(onChange)) {
            onChange(info);
        }
    }

    render() {
        let { data = {}, headers = {} } = this.props;
        // 传递加密参数
        headers['crux'] = String(headers['crux'] || this.defaultCrux);

        //表单提交数据加密  后台需要继承朱威的公共类
        let sysParamJson = getSysterm();
        let appcode = sysParamJson.sys_appcode;
        //chendch修改，导入进度查询唯一标记
        let sys_ts_uap = sysParamJson.sys_ts;
        sysParamJson = encryptFormData(JSON.stringify(sysParamJson));

        let busiParamJson = encryptFormData(JSON.stringify({ ...data, importSign: sys_ts_uap }));

        let uploadData = {
            sysParamJson,
            sys_appcode: appcode,
            busiParamJson,
        };
        return (
            <OriginUpload.Dragger
                {...this.props}
                data={uploadData}
                headers={headers}
                onChange={this.uploadChange}
            />
        );
    }
}

// 添加拖拽模式
Upload.Dragger = OriginUpload.Dragger;
//渐进修改 加密后的Dragger
Upload.EncryptDragger = Dragger;
